import { Col, Form, Input, InputNumber, Row, Select } from 'antd';
import { OCPP_VERSION_LABELS } from '../utils/format';

/** Protocolo OCPP negociable por el cargador; el valor es el enum del contrato. */
const PROTOCOL_OPTIONS = (['ocpp1.6', 'ocpp2.0.1'] as const).map((value) => ({
  value,
  label: OCPP_VERSION_LABELS[value],
}));

/**
 * Paso 1 del alta de Cargador: identidad del equipo. El ChargePoint ID es la clave única
 * (el backend la valida con `EQUIPO_CHARGEPOINT_DUPLICADO`); marca/modelo son opcionales.
 *
 * En `mode="edit"` el ChargePoint ID y el protocolo quedan **deshabilitados**: son
 * inmutables por contrato (el PATCH no los acepta; cambiarlos no re-sincroniza el core).
 * Se muestran —en vez de ocultarse— para que el operador los lea sin salir del formulario.
 */
interface StationIdentityFieldsProps {
  mode?: 'create' | 'edit';
}

export function StationIdentityFields({ mode = 'create' }: StationIdentityFieldsProps) {
  const readOnly = mode === 'edit';

  return (
    <>
      <Form.Item
        label="ChargePoint ID"
        name="id"
        rules={[
          { required: true, whitespace: true, message: 'Ingresa el ChargePoint ID.' },
        ]}
      >
        <Input
          autoComplete="off"
          disabled={readOnly}
          placeholder="Introduzca el ChargePoint ID"
        />
      </Form.Item>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="Marca" name="vendor">
            <Input autoComplete="off" placeholder="Introduzca la marca (p. ej. ABB)" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Modelo" name="model">
            <Input autoComplete="off" placeholder="Introduzca el modelo (p. ej. Terra 54)" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Protocolo"
            name="protocol"
            rules={[{ required: true, message: 'Selecciona el protocolo.' }]}
          >
            <Select
              disabled={readOnly}
              placeholder="Selecciona el protocolo"
              options={PROTOCOL_OPTIONS}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Potencia máx (kW)"
            name="maxPowerKw"
            rules={[
              { required: true, message: 'Ingresa la potencia máxima del gabinete.' },
              {
                type: 'number',
                min: 0.01,
                message: 'La potencia debe ser mayor que 0.',
              },
            ]}
          >
            <InputNumber
              min={0.01}
              step={1}
              style={{ width: '100%' }}
              placeholder="50"
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}
